
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rocni-predplatne",
      function () {
        return require("private-next-pages/rocni-predplatne.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rocni-predplatne"])
      });
    }
  